import sdk from '../services/permissions-sdk';
import { startLoading, endLoading } from './app-dux';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    policies: [
        {
            id: '',
            permissions: [],
            wildcards: [],
            name: ''
        }
    ],
    policy: {
        name: '',
        permissions: [],
        wildcards: []
    }
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_POLICIES   = 'setPolicies';
export const SET_POLICY = 'setPolicy';
const CLEAR_STATE   = 'CLEAR_STATE';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {
    switch ( action.type ) {
        case SET_POLICIES: {
            return {
                ...state,
                policies: action.policies
            };
        }
        case SET_POLICY: {
            return {
                ...state,
                policy: action.policy
            };
        }
        case CLEAR_STATE: {
            return {
                ...initialState
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
export function getPolicies() {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.getPolicies( )
            .then( ( policies )=>{

                const notDeleted = policies.policies.filter( policy => { return policy.deletedat === null;} );
                dispatch( setPolicies( notDeleted ) );
                dispatch( endLoading() );
            }
        );
    };
}
export function getPolicy( policyId ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.getPolicy( policyId )
            .then( ( policy )=>{
                dispatch( setPolicy( policy.policy ) );
                dispatch( endLoading() );
            }
        );
    };
}
export function deletePolicy( policyId ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.deletePolicy( policyId )
            .then( ( policy )=>{
                dispatch( getPolicies() );
            }
        );
    };
}
export function savePolicy( policy ) {
    return ( dispatch ) => {
        return sdk.savePolicy( policy );
    };
}
export function setPolicies( policies ) {
    return {
        type: SET_POLICIES,
        policies
    };
}
export function setPolicy( policy ) {
    return {
        type: SET_POLICY,
        policy
    };
}
export function clearState( ) {
    return {
        type: CLEAR_STATE
    };
}
